/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_New_Chat_MessageInputs */

const cs_enum_new_chat_message = /** @type {(inputs: Enum_New_Chat_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nová zpráva v chatu`)
};

const en_enum_new_chat_message = /** @type {(inputs: Enum_New_Chat_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New chat message`)
};

/**
* | output |
* | --- |
* | "New chat message" |
*
* @param {Enum_New_Chat_MessageInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_new_chat_message = /** @type {((inputs?: Enum_New_Chat_MessageInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_New_Chat_MessageInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_new_chat_message(inputs)
	return cs_enum_new_chat_message(inputs)
});